import { useTheme } from "@mui/material";
import React from "react";
import styled from "styled-components";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { ActivityEventEnum } from "@/pages/scenario-builder/types";
import { getUserName } from "@/pages/scenario-builder/utils/convertToActivity";

import { ActivityItemWrapper, IconContainer, IconWrapper } from "./shared/StyledComponents";
import { Activity } from "./types";

export const StatusChangeActivity: React.FC<{ activity: Activity }> = ({ activity }) => {
  if (activity.eventType !== ActivityEventEnum.ScenarioStatusUpdated) {
    return null;
  }

  // Get status display text (matching the dropdown title case)
  const getStatusText = (eventType: string): string => {
    switch (eventType) {
      case "Approved":
        return "Approved";
      case "Completed":
        return "Ready for Review";
      case "archived":
        return "Archived";
      case "created":
        return "Created";
      default:
        return eventType;
    }
  };

  const theme = useTheme();
  return (
    <ActivityItemWrapper>
      <IconContainer>
        <IconWrapper>
          <StatusIndicator color={activity.data.statusColor} />
        </IconWrapper>
      </IconContainer>
      <Box>
        <Typography variant="body2">
          Status changed to <StatusText>{getStatusText(activity.data.status)}</StatusText>
        </Typography>
        <Typography fontSize={12} sx={{ color: theme.palette.activityLog.user }}>
          {getUserName(activity.user)}
        </Typography>
      </Box>
    </ActivityItemWrapper>
  );
};

const StatusIndicator = styled("div")<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const StatusText = styled("span")`
  font-weight: 600;
`;
